import { getToken } from '@/services/token';
import { map } from 'fp-ts/lib/IOEither';
import { pipe } from 'fp-ts/lib/function';
import { getLocale } from '@/ui/i18n/i18n';

type headersSet = [string, string][];

const setHeaders = (headers: Headers, toSet: headersSet): headersSet => [
  ...headers.entries(),
  ...toSet,
];

//todo: move getLocale to parameter to factories.ts
export const addBaseHeaders = (req: Request) => new Request(req, {
  headers: setHeaders(req.headers, [
    ['Zyp-User-Agent', 'com.lumiformapp.admin.v2.0.0'],
    ['Accept-Language', getLocale()],
  ]),
});

export const addJsonHeaders = (req: Request) => new Request(req, {
  headers: setHeaders(req.headers, [
    ['Content-Type', 'application/json'],
    ['Accept', 'application/json'],
  ]),
});

//it can be form multipart with FormData with legacy urls
//FormData should not have Content-Type headers set
export const addFormHeaders = (req: Request) => {
  req.headers.delete('Content-Type');
  return new Request(req, {
    headers: req.headers,
  });
};

export const addFormWithJsonHeaders = (req: Request) => {
  req.headers.delete('Content-Type');

  return new Request(req, {
    headers: setHeaders(req.headers, [
      ['Accept', 'application/json'],
    ]),
  });
};

export const addAuthorizationHeaders = (req: Request) => pipe(
  getToken(),
  map(token => new Request(req, {
    headers: setHeaders(req.headers, [
      ['Authorization', `Bearer ${token}`],
    ]),
  })),
);

export const addManualAuthorizationHeaders = (token: string) => (req: Request) => new Request(req, {
  headers: setHeaders(req.headers, [
    ['Authorization', `Bearer ${token}`],
  ]),
});

const addVersion = (name: string) => (version: string) => (req: Request) => new Request(
  req,
  {
    headers: setHeaders(req.headers, [
      [name, version],
    ]),
  },
);

export const addVersionForGet = addVersion('If-None-Match');
export const addVersionForUpdate = addVersion('If-Match');
